export default __webpack_public_path__ + "static/media/rik.7a132f27.png";